import { Routes } from '@angular/router';
import { HomePageComponent } from './modules/home/pages/home-page/home-page.component';
import { OnboardingPageComponent } from './modules/onboarding/pages/onboarding-page/onboarding-page.component';
import { FramePageComponent } from './components/frame-page/frame-page.component';
import { BadRequestPageComponent } from './components/bad-request-page/bad-request-page.component';
import { NotFoundPageComponent } from './components/not-found-page/not-found-page.component';

export const routes: Routes = [
  {
    path: "",
    component: FramePageComponent,
    children: [
      {
        path: "pc/:policyCode",
        component: OnboardingPageComponent
      },
      {
        path: "400",
        component: BadRequestPageComponent
      },
      {
        path: "404",
        component: NotFoundPageComponent
      },
      {
        path: '**',
        component: NotFoundPageComponent
      }
    ]
  }
];
